import * as i from "react";
import { u as l, a as d, R as f } from "./index-7nLHFyEB.js";
import { S as p } from "./index-DsTrtXZS.js";
import { jsx as c } from "react/jsx-runtime";
function R(a, e = globalThis == null ? void 0 : globalThis.document) {
  const t = l(a);
  i.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && t(o);
    };
    return e.addEventListener("keydown", r, { capture: !0 }), () => e.removeEventListener("keydown", r, { capture: !0 });
  }, [t, e]);
}
var m = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], v = m.reduce((a, e) => {
  const t = i.forwardRef((r, o) => {
    const { asChild: u, ...n } = r, s = u ? p : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ c(s, { ...n, ref: o });
  });
  return t.displayName = `Primitive.${e}`, { ...a, [e]: t };
}, {}), y = "Portal", P = i.forwardRef((a, e) => {
  var s;
  const { container: t, ...r } = a, [o, u] = i.useState(!1);
  d(() => u(!0), []);
  const n = t || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return n ? f.createPortal(/* @__PURE__ */ c(v.div, { ...r, ref: e }), n) : null;
});
P.displayName = y;
export {
  P,
  R as u
};
